export const flexColumnStyles = `
    display: flex;
    flex-direction: column;
    align-items: stretch;
`;